import { InjectionToken, ProviderToken } from '@angular/core';

export const GAME_ID: ProviderToken<string> = new InjectionToken<string>('game-id');
